import { ExpandMore } from '@mui/icons-material';
// Components
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  Typography
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { FC, useState } from 'react';
import { IMaterialsProvided } from '../../../models';

interface IMobileMaterialsProvided {
  original: IMaterialsProvided;
  setMaterialsProvided: (val) => void;
  materialsProvided: IMaterialsProvided[];
  isDisabled?: boolean;
}

export const MobileMaterialsProvided: FC<IMobileMaterialsProvided> = ({
  original,
  setMaterialsProvided,
  materialsProvided,
  isDisabled
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(true);
  const { description, manufacturer, model } = original;

  const handleAccordionChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setIsOpen(isExpanded);
  };

  return (
    <Accordion className={classes.root} expanded={isOpen} onChange={handleAccordionChange}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">
            <span className={clsx(classes.boldName, classes.subLabel)}>{description}</span>
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Description:
          </FormLabel>
          <Typography component="span" variant="body2">
            {description || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Manufacturer:
          </FormLabel>
          <Typography component="span" variant="body2">
            {manufacturer || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Model:
          </FormLabel>
          <Typography component="span" variant="body2">
            {model || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  undefinedPart: {
    color: theme.palette.error.main
  },
  fieldOrderId: {
    fontSize: '1rem',
    padding: 0,
    marginLeft: '-5px'
  },
  checkboxLabel: {
    fontSize: theme.typography.body2.fontSize,
    position: 'relative',
    top: '.1rem'
  }
}));
